export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="px-10 pt-12 pb-8 border-b border-stone-800 flex items-end justify-between gap-6">
      <div>
        {eyebrow && (
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-orange-500/80 mb-3">
            {eyebrow}
          </div>
        )}
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-50">{title}</h1>
        {subtitle && <p className="mt-3 text-sm text-stone-400 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
      {children && <div className="shrink-0">{children}</div>}
    </div>
  );
}

export function StatBadge({ status = "info", children, ...rest }) {
  const styles = {
    info:    "border-stone-700 text-stone-300",
    success: "border-green-800 text-green-400",
    warning: "border-amber-800 text-amber-400",
    danger:  "border-red-800 text-red-400",
    accent:  "border-orange-700 text-orange-400",
  }[status] || "border-stone-700 text-stone-300";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 border text-[10px] font-mono uppercase tracking-widest ${styles}`} {...rest}>
      {children}
    </span>
  );
}

export function Section({ title, right, children, ...rest }) {
  return (
    <section className="border-b border-stone-800" {...rest}>
      <div className="px-10 py-5 flex items-center justify-between border-b border-stone-800/60">
        <h2 className="text-[11px] font-mono uppercase tracking-[0.3em] text-stone-500">{title}</h2>
        {right}
      </div>
      <div className="px-10 py-6">{children}</div>
    </section>
  );
}
